module.exports = __webpack_public_path__ + "img/PeachPie.1d90964b.webp";